// extracted by mini-css-extract-plugin
export default {"bigBadge":"DailyBadges_bigBadge__X4qK8","dateInput":"DailyBadges_dateInput__yYORL","d-flex":"DailyBadges_d-flex__ck0wl","analyticsText":"DailyBadges_analyticsText__Zc36k"};